module.exports = __webpack_public_path__ + "static/undraw_viral_tweet_gndb-51f9a48bb7755cca1df655465349c875.svg";